var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGapping(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-32-gapping") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-32-gapping",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_distance_2063320",
    transform: "translate(16.500000, 15.709677) rotate(90.000000) translate(-16.500000, -15.709677) translate(3.000000, 7.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.05597723,
    y: 9.32447818,
    width: 2.66413662,
    height: 7.32637571
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 3.73056424e-13,
    y: 10.5540797,
    width: 2.66413662,
    height: 6.09677419
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 12.1679317,
    y: 5.9943074,
    width: 2.66413662,
    height: 10.6565465
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 20.2798861,
    y: 1.99810247,
    width: 2.66413662,
    height: 14.6527514
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 8.11195446,
    y: 7.99240987,
    width: 2.66413662,
    height: 8.65844402
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 16.2239089,
    y: 3.99620493,
    width: 2.66413662,
    height: 12.654649
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 24.3358634,
    y: 7.45726062e-13,
    width: 2.66413662,
    height: 16.6508539
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGapping);
export default __webpack_public_path__ + "static/media/gapping.d2ec6162f9cc04fb1fc7bcba3db83c58.svg";
export { ForwardRef as ReactComponent };